"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = __importStar(require("react"));
var react_2 = require("@emotion/react");
var layout_1 = require("../layout");
var BreadcrumbItem_1 = __importDefault(require("./BreadcrumbItem"));
var BreadcrumbSeparator_1 = __importDefault(require("./BreadcrumbSeparator"));
var defaultRenderSeparator = function () { return react_2.jsx(BreadcrumbSeparator_1.default, null); };
var Breadcrumb = function (props) {
    var _a = props.renderSeparator, renderSeparator = _a === void 0 ? defaultRenderSeparator : _a, className = props.className, children = props.children;
    var crumbs = react_1.default.Children.map(children, function (child, currentIndex) { return (react_2.jsx(react_1.Fragment, null,
        currentIndex !== 0 && renderSeparator(),
        child)); });
    return react_2.jsx(layout_1.Flex, { className: className, alignItems: "center" }, crumbs);
};
Breadcrumb.Separator = BreadcrumbSeparator_1.default;
Breadcrumb.Item = BreadcrumbItem_1.default;
exports.default = Breadcrumb;
